export type SkillCategory = 'web-development' | 'it-infrastructure' | 'databases-tools';

export interface ISkill {
  id: string;
  name: string;
  category: SkillCategory;
  proficiencyPercentage: number;
  iconName: string;
  isPrimaryWebDev: boolean;
  isPrimaryIT: boolean;
}

/**
 * OOP Domain Model for Technical Skills
 */
export class Skill implements ISkill {
  id: string;
  name: string;
  category: SkillCategory;
  proficiencyPercentage: number;
  iconName: string;
  isPrimaryWebDev: boolean;
  isPrimaryIT: boolean;

  constructor(data: ISkill) {
    this.id = data.id;
    this.name = data.name;
    this.category = data.category;
    this.proficiencyPercentage = data.proficiencyPercentage;
    this.iconName = data.iconName;
    this.isPrimaryWebDev = data.isPrimaryWebDev;
    this.isPrimaryIT = data.isPrimaryIT;
  }

  public getProficiencyLabel(): string {
    if (this.proficiencyPercentage >= 90) return 'Advanced / Expert';
    if (this.proficiencyPercentage >= 75) return 'Proficient';
    if (this.proficiencyPercentage >= 60) return 'Intermediate';
    return 'Foundational';
  }

  public isRelevantForRole(role: 'web-developer' | 'it-specialist' | 'all'): boolean {
    if (role === 'all') return true;
    if (role === 'web-developer') return this.isPrimaryWebDev;
    if (role === 'it-specialist') return this.isPrimaryIT;
    return true;
  }
}
